import React, { Component } from 'react';
import './ServiceStatus.css';
import MoreInformation from '../MoreInformation/MoreInformation.jsx';
import MonitorApi from '../../utils/MonitorApi';
import { Button } from 'react-bootstrap';


var StateActions = require('../../actions/StateActions');

var Translate   = require('react-translate-component');
var serviceStatesMap = {normal:{color:'success',icon:'icon-check-circle'},maintenance:{color:'maintenance',icon:'icon-message-circle'},warning:{color:'warning',icon:'icon-cloud-lightning'},critical:{color:'danger',icon:'icon-alert-triangle'}};


export default class ServiceStatus extends Component {



  constructor(props) {
    super(props);
    this.state = {service:this.props.service,editMode:false};
    this.isAuthorized = MonitorApi.isAuthorized();
    this.updateService = this.updateService.bind(this);
    this.handleAutomaticChange = this.handleAutomaticChange.bind(this);
    this.handleAutomaticChange = this.handleAutomaticChange.bind(this);
    this.handleManualChange = this.handleManualChange.bind(this);
    this.editModeService = this.editModeService.bind(this);
    //this.updateServiceStatus = this.updateServiceStatus.bind(this);
    //this.generateEditStatus = this.generateEditStatus.bind(this);
  }

  updateService(){
    StateActions.updateState(this.state.service);
    this.editModeService();
  }

  handleManualChange (){
    var tempService = this.state.service;
    tempService.automatic = false;
    this.setState({service: tempService});
  }

  handleAutomaticChange(){
    var tempService = this.state.service;
    tempService.automatic = true;
    this.setState({service: tempService});
  }

  updateServiceStatus(newState){
    var tempService = this.state.service;
    tempService.state = newState.target.value;
    this.setState({service: tempService});
  };

  editModeService(){
    this.setState({editMode:!this.state.editMode});
  }

  generateEditStatus(currentStatus){
    var serviceVisualEdit = [];
    var updateServiceStatus = this.updateServiceStatus.bind(this);
    Object.keys(serviceStatesMap).forEach(function (key) {
      serviceVisualEdit.push(
        <div className="col-xs-3" key={key} >
            <div className="centerAll">
              <input onClick={updateServiceStatus}
                     type="button"
                     value={key}
                     className={"no_style service_status clickable centerAll " + (serviceStatesMap[key].color + '_status ') + (currentStatus === key ? 'selected' : undefined)} readOnly>
              </input>
          </div>
        </div>);
    });
    return serviceVisualEdit;
  }

  render() {
    return (
      <div className="col-xs-12 col-sm-6 col-md-3">
      {
        this.state.service ?
          this.isAuthorized & this.state.editMode ?
            <div className="service_status_block"> 
              <div className="question_button">
                <MoreInformation info={'watchdog.services.' + this.state.service.name + '.info'}/>
              </div>
              <div className="service_status_block_edit_mode">
                <Button onClick={this.editModeService}
                        className='centerAll no_style edit_button'><span className="icon_button icon-edit-2"></span>
                </Button>
              </div>
              <div className="centerAll"> 
                <div className="col-xs-12"> 
                  {this.generateEditStatus(this.state.service.state)} 
                </div>
               </div>
              <div className="centerAll">
                <p><Translate component="b" content={'watchdog.services.' + this.state.service.name + '.title'}/></p> 
              </div>
              <div> 
                <div className="col-xs-12 centerAll"> 
                  <div className="selector-tile">
                    <div onClick={this.handleAutomaticChange}
                         className={"selector-tile-left " + (this.state.service.automatic ? "selected-tile" : undefined) }>
                      <Translate component="span" content="watchdog.services.edit.automatic"/>
                    </div> 
                    <div onClick={this.handleManualChange}
                         className={"selector-tile-right " + (!this.state.service.automatic ? "selected-tile" : undefined) }> 
                      <Translate component="span" content="watchdog.services.edit.manual"/>
                    </div>
                  </div> 
                </div> 
                <div className="col-xs-12 marginToTop">
                   <Button onClick={this.updateService} className="no_style save_button col-xs-6 col-xs-offset-3 btn btn-default">save</Button> 
                </div> 
              </div>
             </div>
          :<div className="service_status_block">
            <div>
              {this.isAuthorized?
              <Button onClick={this.editModeService}
                      className='centerAll no_style edit_button service_status_block_edit_mode '><span className="icon_button icon-edit-2"></span>
              </Button>
                :undefined
              }
            </div>
            <Translate component="p" className="col-xs-12 service_status_block_title status_block_title" content={'watchdog.services.' + this.state.service.name + '.title'}/>
            <div className="col-xs-12">
              <div className="centerAll service_block_height">
                <div>
                  <div>
                    <div className={"service_status_icon no_edit_status " + serviceStatesMap[this.state.service.state].icon  + " " + (serviceStatesMap[this.state.service.state].color + '_status_color')}></div>
                  </div>
                </div>
              </div>
            </div>
            <div className="question_button">
              <MoreInformation info={'watchdog.services.' + this.state.service.name + '.info'}/>
            </div>
          </div>


        :undefined
      }
      </div>

    );
  }
}


/** WEBPACK FOOTER **
 ** ./src/components/ServiceStatus/ServiceStatus.jsx
 **/